if ($(window).width() >= 1024 ) {
  setTimeout(function () {
      $('body').click(function () {
          $('.hawk-searchQuery').removeClass("d-flex");
      });
  
      $('.hawk-searchQuery').on('DOMSubtreeModified', function () {
          if ($("#searchInput").val().length == 1) {
              $('.hawk-searchQuery').removeClass("d-flex");
          }
  
          else {
              var header1 = $(".hawk-sqHeader:first-child");
              $(this).addClass("d-flex");
              $(".hawk-sqContent:first-child").addClass("border-right-grey");
              $(".hawk-sqContent:first-child").addClass("px-4");
              $(".hawk-sqContent:nth-child(3)").addClass("pl-2");
              $(".hawk-sqHeader").remove();
              $(".hawk-sqContent:first-child").prepend(header1);
          }
      });
  }, 500);
}

$(window).resize(function () {
  var width = $(window).width();
  if (width < 1200) {
      $(".subheader").removeClass("d-flex");
  }
});

if ($(window).width() < 1200) {
  $(".subheader").removeClass("d-flex");
}
// Sticky menu
// Función para agregar y quitar una clase que solucione el menú sticky en desk para todas las home
window.onscroll = function() {scrollFunction()};
function scrollFunction() {
  
  if (document.documentElement.scrollTop > 10 && $(window).width() > 991) {
    $(".site-header").addClass("menusticky");
    $(".fix-header").css({marginTop: '180px'});
    
  } else {
    $(".site-header").removeClass("menusticky")
    $(".fix-header").css({marginTop: '0px'});
  }
}
